import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { upComingMeeting } from '../models/upcomingMeetingModel';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AgoraConfigService } from 'src/AgoraConfigService';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  httpHeaders: any;
  agoraConfigObject: any;

  constructor(private http: HttpClient, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.httpHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
  }

  loadDocumentMeeting(jsonReq:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.dashboard}` + "/documentMeetings", jsonReq, { headers: this.httpHeaders })
    .pipe(map((data) => {
      return data;
    }), catchError(error => {
      return throwError('Something went wrong!');
    })
    )
  }

  documentMeetingCount(jsonReq: any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.dashboard}` + "/fetchDocumentMeetingCount", jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      ) 
  }

  loadUpcomingMeetings(jsonReq: any) {
 return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.dashboard}` + "/upcomingMeetings", jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      ) 
  }

  loadDocumentMeetings(jsonReq: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.dashboard}` + "/documentMeetings", jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  };
  loadPastMeetings(jsonReq: any) {
    let target = '/pastMeetings'
    if(jsonReq.isDocMeeting!=undefined && jsonReq.isDocMeeting=="Y"){
      target = '/documentPastMeetings'
    }
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.dashboard}` + target, jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        //
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  };
  loadAnnoucements(){
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.dashboard}` + "/announcements/agora",{ headers: this.httpHeaders });
  }
  loadTasks(jsonReq: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.dashboard}` + "/dashboardTasks", jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  };
  searchTasks(jsonReq: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}` + "taskSearch", jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  };
  searchMeetings(jsonReq: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.solrSearch}` + "searchMeetings", jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  };
  globalSearch(jsonReq: any) {
    
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.search}` + "/globalSearch", jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  };
}
